var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { createGlobalStyle } from "styled-components";
import Futura from "./FuturaBTBook.woff";
import Futura2 from "./FuturaBTBook.woff2";
import FuturaMedium from "./FuturaBTMedium.woff";
import FuturaMedium2 from "./FuturaBTMedium.woff2";
export var AamiFonts = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: FuturaBT;\n    src: url(", ") format('woff2'), url(", ") format('woff');\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: FuturaBT;\n    src: url(", ") format('woff2'), url(", ") format('woff');\n    font-weight: 600;\n    font-style: normal;\n  }\n"])), Futura2, Futura, FuturaMedium2, FuturaMedium);